// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// driver components
import SelectDriver from '../../components/SelectDriver/SelectDriver';

// driver events
import driverSelectedEvent from '../../events/selected.event.driver';
import showSelectDriverEvent from '../../events/showSelectDriver.event.driver';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

// redux
import {connect} from 'react-redux';

// spotlight events
import onSearchInputEvent from '../../../spotlight/events/onSearchInput.event.spotlight';

class SelectDriverContainer extends Component {
  static propTypes = {
    drivers: PropTypes.array,
    driversLoading: PropTypes.bool,
    subscribe: PropTypes.func,
  };

  state = {
    visible: false,
    search: '',
  };

  componentDidMount() {
    this.props.subscribe(showSelectDriverEvent.subscribe(this.show));
  }

  show = () => {
    this.setState({visible: true, search: ''});
  };

  hide = () => {
    this.setState({visible: false});
  };

  onSearch = (search) => {
    if (search?.length > 2)
      onSearchInputEvent.publish(search, {domain: ['driver']});
    this.setState({search});
  };

  onDriver = (driver) => () => this.selectDriver(driver);

  selectDriver = (driver) => {
    if (!driver) return alert.warning('Select a driver');
    driverSelectedEvent.publish(driver);
    this.hide();
  };

  drivers = () => {
    const {driver, drivers} = this.props;
    const {search} = this.state;
    if (search?.length <= 2 && !driver) return [];
    const formattedSearch = `${search}`.toLocaleLowerCase();
    const filteredDrivers = !formattedSearch.trim().length
      ? drivers
      : [...drivers].filter((driverToFilter) =>
          `${driverToFilter.first_name} ${
            driverToFilter.last_name
          } ${driverToFilter.fhv_license_number ||
            ''} ${driverToFilter.phone_number || ''}`
            .toLowerCase()
            .includes(formattedSearch)
        );
    const driversWithoutSelectedDriver = !!driver
      ? [...filteredDrivers].filter(
          (driverToFilter) => driverToFilter.id !== driver.id
        )
      : filteredDrivers;
    const driverWithSelectedDriver = !!driver
      ? [driver, ...driversWithoutSelectedDriver]
      : driversWithoutSelectedDriver;
    return [...driverWithSelectedDriver]
      .sort((a, b) => {
        const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
        const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      })
      .splice(0, 10);
  };

  render() {
    const {driver, driversLoading} = this.props;
    const {visible, search} = this.state;
    return (
      <SelectDriver
        driver={driver}
        drivers={this.drivers()}
        loading={driversLoading}
        onClose={this.hide}
        onDriver={this.onDriver}
        onSearch={this.onSearch}
        search={search}
        visible={visible}
      />
    );
  }
}

export default connect((state) => ({
  drivers: state.spotlight.drivers,
  driversLoading: state.spotlight.driversLoading,
}))(subscriptionHOC(SelectDriverContainer));
